import { Circle, CircleDot } from 'lucide-react';

interface RadioListItemProps {
  title: string;
  subtitle?: string;
  selected: boolean;
  onClick: () => void;
}

export const RadioListItem = ({ title, subtitle, selected, onClick }: RadioListItemProps) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 p-4 hover:bg-[#F7F8FA] transition-colors"
    >
      <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${
        selected ? 'text-[#FF6A2A]' : 'text-[#E5E7EB]'
      }`}>
        {selected ? (
          <CircleDot className="w-6 h-6" />
        ) : (
          <Circle className="w-6 h-6" />
        )}
      </div>
      <div className="flex-1 text-left">
        <p className={`font-medium ${selected ? 'text-[#111827]' : 'text-[#6B7280]'}`}>
          {title}
        </p>
        {subtitle && (
          <p className="text-xs text-[#6B7280] mt-0.5">{subtitle}</p>
        )}
      </div>
    </button>
  );
};
